module.exports = __webpack_public_path__ + "img/swiperLast.ddeb4a56.svg";